import React, { useState, useMemo, useEffect } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { ChevronLeft, ChevronRight } from "../../Auditoria/Helper/Icons";
import PlantillaScreen from '../../helpers/PlantillaScreen';
import '../../../Styles/RedesSociales/_RS_Main.scss'
import { RSAñadirModal } from "./RSAñadirModal ";
import { RSTipoPublicacionModal } from "./RSTipoPublicacionModal";
import { RSReelsModal } from "./RSReelsModal";
import { MONTHS_ES, DAYS_ES, getDaysInMonth, getFirstDayOfMonth } from "./Helper/calendarioUtils";

export const RedesSocialesMainScreen = () => {
    const today = new Date();
    const [listado, setListado] = useState([]);
    const [loading, setLoading] = useState(true);
    const [calYear, setCalYear] = useState(today.getFullYear());
    const [calMonth, setCalMonth] = useState(today.getMonth());
    const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
    const [cargandoEvento, setCargandoEvento] = useState(false);

    const prevMonth = () => { if (calMonth === 0) { setCalMonth(11); setCalYear(y => y - 1); } else setCalMonth(m => m - 1); };
    const nextMonth = () => { if (calMonth === 11) { setCalMonth(0); setCalYear(y => y + 1); } else setCalMonth(m => m + 1); };

    const [openModalTipo, setOpenModalTipo] = useState(false);
    const [openModalAnadir, setOpenModalAnadir] = useState(false);
    const [openModalReels, setOpenModalReels] = useState(false);
    const [modoReelInicial, setModoReelInicial] = useState("Automatico");

    const calCells = useMemo(() => {
        const firstDay = getFirstDayOfMonth(calYear, calMonth);
        const daysInMon = getDaysInMonth(calYear, calMonth);
        const prevDays = getDaysInMonth(calYear, calMonth === 0 ? 11 : calMonth - 1);
        const cells = [];
        for (let i = firstDay - 1; i >= 0; i--)
            cells.push({ day: prevDays - i, current: false, month: calMonth === 0 ? 11 : calMonth - 1, year: calMonth === 0 ? calYear - 1 : calYear });
        for (let d = 1; d <= daysInMon; d++)
            cells.push({ day: d, current: true, month: calMonth, year: calYear });
        const remaining = 35 - cells.length;
        for (let d = 1; d <= remaining; d++)
            cells.push({ day: d, current: false, month: calMonth === 11 ? 0 : calMonth + 1, year: calMonth === 11 ? calYear + 1 : calYear });
        return cells;
    }, [calYear, calMonth]);

    // Filtra los eventos del día y los ordena de menor a mayor por hora
    const eventsForCell = (cell) => {
        return listado
            .filter(ev => {
                const fecha = new Date(ev.fecha_Envio);
                return (
                    fecha.getDate() === cell.day &&
                    fecha.getMonth() === cell.month &&
                    fecha.getFullYear() === cell.year
                );
            })
            .sort((a, b) => {
                const horaA = a.hora || a.Hora || "";
                const horaB = b.hora || b.Hora || "";

                // Si uno no tiene hora, se manda al final
                if (!horaA) return 1;
                if (!horaB) return -1;

                // Comparación directa de strings de tiempo (ej: 09:00 < 14:30)
                return horaA.localeCompare(horaB);
            });
    };

    const isToday = (cell) =>
        cell.current &&
        cell.day === today.getDate() &&
        cell.month === today.getMonth() &&
        cell.year === today.getFullYear();

    useEffect(() => {
        onCargarDatos();
    }, []);

    const onCargarDatos = () => {
        setLoading(true);
        request
            .get("Encabezado/Calendario")
            .then((result) => {
                setListado(result ?? []);
            })
            .catch((error) => {
                Swal.fire("REDES SOCIALES", JSON.stringify(error), "error");
            })
            .finally(() => setLoading(false));
    };

    // Al elegir el tipo en el selector, abre el modal correspondiente para un registro nuevo
    const onSeleccionarTipoNuevo = (tipo, modoReel) => {
        setOpenModalTipo(false);
        setEventoSeleccionado(null);
        if (tipo === "Reel") {
            setModoReelInicial(modoReel ?? "Automatico");
            setOpenModalReels(true);
        } else {
            setOpenModalAnadir(true);
        }
    };

    // Carga el detalle completo del folio solo hasta que el usuario da click en el evento,
    // enrutando a Encabezado (Imagen) o Reels_Encabezado según el tipo del evento
    const onSeleccionarEvento = (ev) => {
        setCargandoEvento(true);

        if (ev.tipo_Evento === "Reel") {
            request
                .get(`Reels_Encabezado/Listado?folio=${ev.folio}`)
                .then((result) => {
                    const detalle = Array.isArray(result) ? result[0] : result;
                    setEventoSeleccionado({ ...ev, ...detalle });
                    setOpenModalReels(true);
                })
                .catch((error) => {
                    Swal.fire("REDES SOCIALES", JSON.stringify(error), "error");
                })
                .finally(() => setCargandoEvento(false));
            return;
        }

        request
            .get(`Encabezado/Listado?folio=${ev.folio}`)
            .then((result) => {
                const detalle = Array.isArray(result) ? result[0] : result;
                setEventoSeleccionado({ ...ev, ...detalle });
                setOpenModalAnadir(true);
            })
            .catch((error) => {
                Swal.fire("REDES SOCIALES", JSON.stringify(error), "error");
            })
            .finally(() => setCargandoEvento(false));
    };


    return (
        <PlantillaScreen titulo="REDES SOCIALES" className="rs-root">
            <div className="rs-calendar-panel">


                <div className="rs-cal-toolbar">
                    <button className="rs-cal-nav__btn" onClick={prevMonth} title="Mes anterior">
                        <ChevronLeft />
                    </button>

                    <div className="rs-cal-nav__label">
                        <span className="rs-cal-nav__month">{MONTHS_ES[calMonth]}</span>
                        <span className="rs-cal-nav__year">{calYear}</span>
                    </div>

                    <button className="rs-cal-nav__btn" onClick={nextMonth} title="Mes siguiente">
                        <ChevronRight />
                    </button>

                    <button className="rs-btn rs-btn--primary" onClick={() => setOpenModalTipo(true)}>
                        + Añadir
                    </button>

                </div>

                {loading && (
                    <div className="rs-loading">
                        <div className="rs-loading__spinner" />
                        <span>Cargando...</span>
                    </div>
                )}

                {!loading && (
                    <div className="rs-cal-container">
                        <div className="rs-cal-grid">
                            {DAYS_ES.map(d => (
                                <div key={d} className="rs-cal-grid__header">{d}</div>
                            ))}
                            {calCells.map((cell, i) => {
                                const events = eventsForCell(cell);
                                return (
                                    <div key={i} className={`rs-cal-cell ${!cell.current ? "other-month" : ""} ${isToday(cell) ? "today" : ""}`}>
                                        <span className="rs-cal-cell__num">{cell.day}</span>
                                        <div className="rs-cal-cell__events">
                                            {events.map((ev, idx) => {
                                                const horaEvento = ev.hora || ev.Hora;
                                                const esReel = ev.tipo_Evento === "Reel";
                                                return (
                                                    <div key={idx} className={`rs-event ${esReel ? "rs-event--reel" : ""} ${cargandoEvento ? "rs-event--cargando" : ""}`} title={`${horaEvento ? horaEvento + ' - ' : ''}${ev.folio}`}
                                                        onClick={() => { if (!cargandoEvento) onSeleccionarEvento(ev); }}>

                                                        <span className="rs-event__folio">
                                                            {esReel ? '▶ ' : ''}{horaEvento ? `${horaEvento} — ` : ''}{ev.folio}
                                                        </span>

                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </div>
            <RSTipoPublicacionModal
                open={openModalTipo}
                onClose={() => setOpenModalTipo(false)}
                onSeleccionar={onSeleccionarTipoNuevo}
            />
            <RSAñadirModal
                open={openModalAnadir}
                onClose={() => { setOpenModalAnadir(false); setEventoSeleccionado(null); }}
                onActualizar={onCargarDatos}
                eventoSeleccionado={eventoSeleccionado}
            />
            <RSReelsModal
                open={openModalReels}
                onClose={() => { setOpenModalReels(false); setEventoSeleccionado(null); }}
                onActualizar={onCargarDatos}
                eventoSeleccionado={eventoSeleccionado}
                modoInicial={modoReelInicial}
            />
        </PlantillaScreen>
    );
};

export default RedesSocialesMainScreen;